import { render, staticRenderFns } from "./KpiLink.vue?vue&type=template&id=ad069054&scoped=true&"
import script from "./KpiLink.vue?vue&type=script&lang=js&"
export * from "./KpiLink.vue?vue&type=script&lang=js&"
import style0 from "./KpiLink.vue?vue&type=style&index=0&id=ad069054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad069054",
  null
  
)

export default component.exports